import { useRecoilState } from "recoil";
import { popupButtonVisibleState } from "recoils/common/commonState";

const usePopupButton = () => {
  const [visiblePopupButton, setVisiblePopupButton] = useRecoilState(
    popupButtonVisibleState
  );
  const closePopupButton = () => {
    setVisiblePopupButton((prev) => ({
      ...prev,
      isopen: false,
    }));
  };
  const openPopupButton = (type) => {
    return setVisiblePopupButton((prev) => ({
      ...prev,
      isopen: true,
      type: type,
    }));
  };
  return {
    visiblePopupButton,
    openPopupButton,
    closePopupButton,
  };
};
export default usePopupButton;
